/**
 * Cart event bus — the seam between the renderer SDK (which knows nothing about the host app's
 * cart) and the Next.js CartProvider. A product "Ajouter au panier" button calls {@link emitAddToCart};
 * the host app listens for {@link ADD_TO_CART_EVENT} on `window` and updates its cart state. This keeps
 * the SDK framework-agnostic (no React-context dependency on the consuming app).
 */
export const ADD_TO_CART_EVENT = "apa:add-to-cart";

/** One cart line as emitted by a product page. Amounts are in euros (display only — the commerce
 *  API re-prices authoritatively from the content DB by `slug` at checkout). */
export interface CartLineInput {
  slug: string;
  title: string;
  price: number;
  consigne: number;
  image?: string;
  reference?: string;
  quantity: number;
  /** How an eligible exchange-standard line handles the old core. */
  coreOption?: "deposit" | "return_first";
}

/** Dispatch an add-to-cart request to the host app (no-op during SSR). */
export function emitAddToCart(detail: CartLineInput): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<CartLineInput>(ADD_TO_CART_EVENT, { detail }));
}
